import { getApiBackendUrl, getBaseUrl } from '../../_services/_hostingenvironments_/hostingEnvironments';
import axios from "axios";

export const login = async (email, password) => {
  const source = axios.CancelToken.source();
    try {
      let url = getBaseUrl()
      url += 'uadmin/auth';

      const body = {
        "email":email,
        "password":password, 
      };
  
      const response = await axios.post(url, body, {
        cancelToken: source.token,
        headers: {
          'Content-Type': 'application/json',
          'IDENTITY_KEY': "baritono2"
        }
      }); 
  
      const data = await response.data;
      return data;
    } catch (error) {
      console.error('Error en la llamada a la API:', error);
      throw error;
    } finally {
      // Cancela la solicitud si es necesario
      source.cancel('Request completed or component unmounted');
    }
  };
  
  export const send2FACode = async (userId) => {
    try {
      let url = getBaseUrl() + `uadmin/2fa/${userId}`;
      
      const response = await axios.post(url, null, {
        headers: {
          'Content-Type': 'application/json',
          'IDENTITY_KEY': "baritono2"
        }
      });
  
      return response.data;
    } catch (error) {
      console.error('Error al enviar código 2FA:', error);
      throw error;
    }
  };

  export const validate2FACode = async (userId, code) => {
    try {
      let url = getBaseUrl() + `uadmin/2fa/${userId}/check/${code}`;
      
      const response = await axios.get(url, {
        headers: {
          'Content-Type': 'application/json',
          'IDENTITY_KEY': "baritono2"
        }
      });
  
      return response.status === 200;
    } catch (error) {
      console.error('Error al validar código 2FA:', error);
      throw error;
    }
  };



export const sendResetPasswordEmail = async (email) => {
  try {
    let url = getBaseUrl() + `uadmin/userid/${email}/password?emailsend=true`;
    const data = {};
    const response = await axios.put(url, data,  {
      headers: {
        'Content-Type': 'application/json',
        'IDENTITY_KEY': "baritono2"
      }
    });

    return { data: response.data, error: null };
  } catch (error) {
    console.error('Error al enviar correo de restablecimiento de contraseña:', error);
    return { data: null, error: error.message };
  }
};

export const ssoFlowbirdCallback = async (code, redirectUri) => {
  try {
    const url = getApiBackendUrl() + 'uadmin/sso/flowbird/callback';

    const response = await axios.post(url, { code, redirect_uri: redirectUri }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });

    return response.data;
  } catch (error) {
    console.error('Error en el callback SSO de Flowbird:', error);
    throw error;
  }
};
